// Time-range options for the SEO Performance screen.
//
// Snapshots are captured weekly on a strictly regular 7-day cadence, so a range
// is simply the last N array elements — no date-gap handling is needed. Ranges
// are expressed in WEEKS rather than months so the slice is exact: "3 months"
// as a calendar calculation would land mid-week and silently drop or duplicate
// a point.

export const RANGES = [
  { id: "4w",  label: "4 weeks",   weeks: 4    },
  { id: "12w", label: "3 months",  weeks: 12   },
  { id: "26w", label: "6 months",  weeks: 26   },
  { id: "52w", label: "12 months", weeks: 52   },
  { id: "all", label: "All",       weeks: null },
];

/**
 * Opens on 6 months — the same window the screen showed before the selector
 * existed, so adding it changes nothing for anyone who ignores it.
 */
export const DEFAULT_RANGE = "26w";

/** Look up a range by id, falling back to the default for an unknown one. */
export function rangeById(rangeId) {
  return RANGES.find((r) => r.id === rangeId)
    || RANGES.find((r) => r.id === DEFAULT_RANGE);
}

/**
 * The most recent N snapshots for a range.
 *
 * A TAIL slice, deliberately: snapshots arrive oldest-first, and every range
 * means "the last N weeks". Taking from the front would return the oldest data
 * — the exact opposite — and would look plausible while being wrong.
 *
 * Requesting more weeks than exist returns everything rather than erroring: a
 * 12-month selection on 8 months of history is a normal state, not a fault.
 *
 * @param {Array}  snapshots - chronological (oldest first)
 * @param {string} rangeId
 * @returns {Array} chronological slice, order preserved for the trend math
 */
export function sliceToRange(snapshots, rangeId) {
  const list = Array.isArray(snapshots) ? snapshots : [];
  const { weeks } = rangeById(rangeId);
  if (!weeks || weeks >= list.length) return list;
  return list.slice(-weeks);
}

/** Human label for the active range, for empty-state copy. */
export function rangeLabel(rangeId) {
  return rangeById(rangeId).label;
}
